{
  "jira-nin-grid-navigation-onboarding.closeButton": [
    {
      "type": 0,
      "value": "Close"
    }
  ],
  "jira-nin-grid-navigation-onboarding.enterEscapeNavigation": [
    {
      "children": [
        {
          "type": 0,
          "value": "Enter"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " activates inline edit mode while "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Escape"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " returns you to cell navigation."
    }
  ],
  "jira-nin-grid-navigation-onboarding.heading": [
    {
      "type": 0,
      "value": "Improved keyboard navigation"
    }
  ],
  "jira-nin-grid-navigation-onboarding.homeEndPageNavigation": [
    {
      "children": [
        {
          "type": 0,
          "value": "Home"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " skips to the first cell in a row, "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "End"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " to the last. "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Page Down"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " scrolls 1 page down, "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Page Up"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " scrolls 1 page up, keeping focus in the same cell."
    }
  ],
  "jira-nin-grid-navigation-onboarding.moreShortcuts": [
    {
      "type": 0,
      "value": "More shortcuts"
    }
  ],
  "jira-nin-grid-navigation-onboarding.okButton": [
    {
      "type": 0,
      "value": "Ok"
    }
  ],
  "jira-nin-grid-navigation-onboarding.tabAndArrowNavigation": [
    {
      "children": [
        {
          "type": 0,
          "value": "Tab"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " into and out of the view quickly, and use "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "arrow keys"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " to navigate cells."
    }
  ],
  "jira-nin-paid-list-merge-modal-onboarding.copyListSettingsDescription": [
    {
      "type": 0,
      "value": "We've applied your settings from All work view. Do you want to apply your settings from the old List view instead? This includes the filters, groups, and columns you've set."
    }
  ],
  "jira-nin-paid-list-merge-modal-onboarding.copyListSettingsImageAltText": [
    {
      "type": 0,
      "value": "Illustration of multiple spaces stacked to show everything will migrate together."
    }
  ],
  "jira-nin-paid-list-merge-modal-onboarding.copyListSettingsImageAltTextCurrentSpace": [
    {
      "type": 0,
      "value": "Illustration of a single space showing the list settings will migrate to the new view."
    }
  ],
  "jira-nin-paid-list-merge-modal-onboarding.copyListSettingsImageAltTextNo": [
    {
      "type": 0,
      "value": "Illustration of a cursor selecting the More actions menu to choose migrate later."
    }
  ],
  "jira-nin-paid-list-merge-modal-onboarding.copyListSettingsNo": [
    {
      "type": 0,
      "value": "No, keep my settings from the All work view"
    }
  ],
  "jira-nin-paid-list-merge-modal-onboarding.copyListSettingsNoDescription": [
    {
      "type": 0,
      "value": "You can apply old List view settings later in the More actions (...) menu in the list."
    }
  ],
  "jira-nin-paid-list-merge-modal-onboarding.copyListSettingsYesAllSpaces": [
    {
      "type": 0,
      "value": "Yes, apply settings from all Jira spaces"
    }
  ],
  "jira-nin-paid-list-merge-modal-onboarding.copyListSettingsYesSingleSpace": [
    {
      "type": 0,
      "value": "Yes, apply settings from "
    },
    {
      "type": 1,
      "value": "spaceName"
    },
    {
      "type": 0,
      "value": " space"
    }
  ],
  "jira-nin-paid-list-merge-modal-onboarding.description": [
    {
      "type": 0,
      "value": "We've combined the best of List and All Work views to bring you one powerful, unified view for managing work."
    }
  ],
  "jira-nin-paid-list-merge-modal-onboarding.heading": [
    {
      "type": 0,
      "value": "List and All Work are merging"
    }
  ],
  "jira-nin-paid-list-merge-modal-onboarding.learnMoreLink": [
    {
      "type": 0,
      "value": "Read our announcement on Community"
    }
  ],
  "jira-nin-paid-list-merge-modal-onboarding.spaceNameFallback": [
    {
      "type": 0,
      "value": "current"
    }
  ],
  "jira-nin-paid-list-merge-modal-onboarding.spotlight.apply-settings-button-label": [
    {
      "type": 0,
      "value": "Apply settings"
    }
  ],
  "jira-nin-paid-list-merge-modal-onboarding.spotlight.dismiss": [
    {
      "type": 0,
      "value": "Dismiss"
    }
  ],
  "jira-nin-paid-list-merge-modal-onboarding.spotlight.explore-list-view-button-label": [
    {
      "type": 0,
      "value": "Explore List view"
    }
  ],
  "jira-nin-paid-list-merge-modal-onboarding.spotlight.filter": [
    {
      "type": 0,
      "value": "Search, filter, and group work items to quickly find what you need."
    }
  ],
  "jira-nin-paid-list-merge-modal-onboarding.spotlight.more-actions": [
    {
      "type": 0,
      "value": "Adjust how you visualise the work with charts and format rules. You can also apply your old list settings."
    }
  ],
  "jira-nin-paid-list-merge-modal-onboarding.spotlight.next": [
    {
      "type": 0,
      "value": "Next"
    }
  ],
  "jira-nin-paid-list-merge-modal-onboarding.spotlight.ok": [
    {
      "type": 0,
      "value": "OK"
    }
  ],
  "jira.nin.filter.refinement.filter-popup.changeboarding.ok": [
    {
      "type": 0,
      "value": "OK"
    }
  ],
  "jira.nin.filter.refinement.filter-popup.changeboarding.text": [
    {
      "type": 0,
      "value": "Find work faster using filters."
    }
  ],
  "jira.nin.filter.refinement.filter-popup.changeboarding.text.advanced.jql": [
    {
      "type": 0,
      "value": "Select advanced or JQL mode to filter by more fields."
    }
  ],
  "jira.nin.filter.refinement.filter-popup.changeboarding.title": [
    {
      "type": 0,
      "value": "A new home for filters"
    }
  ]
}